import React from 'react';
import PropTypes from 'prop-types';
import { Text, Box } from '@qga/roo-ui/components';
import pluralize from 'pluralize';

const OfferGuestsText = ({ guests, numberOfNights, from = true, ...rest }) => {
  const message = `${pluralize('guest', guests, true)} • ${pluralize('night', numberOfNights, true)}${from ? ' from' : ''}`;

  return (
    <Box {...rest}>
      <Text data-testid="offer-guest-text" color={'greys.steel'} {...rest} line-height="24px">
        {message}
      </Text>
    </Box>
  );
};

OfferGuestsText.propTypes = {
  guests: PropTypes.number.isRequired,
  numberOfNights: PropTypes.number.isRequired,
  from: PropTypes.bool,
};

export default OfferGuestsText;
